import {configureStore} from "@reduxjs/toolkit";
import authenticationSlice from "@/store/reducers/authenticationSlice.ts";
import mainSlice from "@/store/reducers/mainSlice.ts";
import AuctionSlice from "@/store/reducers/auctionSlice.ts";
import messageSlice from "@/store/reducers/messageSlice.ts";
import listingSlice from "@/store/reducers/listingSlice.ts";
import dashboardSlice from "@/store/reducers/dashboardSlice.ts";
import vehicleSlice from "@/store/reducers/vehicleSlice.ts";


export const store = configureStore(
    {
        reducer: {
            authentication: authenticationSlice.reducer,
            main: mainSlice.reducer,
            auction: AuctionSlice.reducer,
            messages: messageSlice.reducer,
            listing: listingSlice.reducer,
            dashboard: dashboardSlice.reducer,
            vehicle: vehicleSlice.reducer,
        },
    }
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export * from './hooks.ts'
export * from './reducers/mainSlice.ts'
export * from './reducers/authenticationSlice.ts'
export * from './reducers/auctionSlice.ts'
export * from './reducers/messageSlice.ts'
export * from './reducers/listingSlice.ts'
export * from './reducers/dashboardSlice.ts'
export * from './reducers/vehicleSlice.ts'
export * from './thunks/createVehicleThunk.ts'
export * from './thunks/editVehicleThunk.ts'
